import { WidgetSize } from 'shared/constants/widgets'

// widget content is built for this fixed aspect ratio. WidgetWrapper scales
// it down to fit whatever box it's given, and Marketplace reuses these
// numbers for its drag-ghost preview.
export const WIDGET_NATURAL_WIDTH = 400

export const WIDGET_NATURAL_HEIGHTS: Record<WidgetSize, number> = {
  [WidgetSize.SMALL]: 95,
  [WidgetSize.MEDIUM]: 210,
  [WidgetSize.LARGE]: 325
}

// a collapsed widget is a fixed-height header strip, whatever its size
export const WIDGET_COLLAPSED_HEIGHT = 52

export const DEFAULT_WIDGET_SIZE: WidgetSize = WidgetSize.MEDIUM
